module.exports = __webpack_public_path__ + "static/director-59a91bd3bc3653eca76f68ff3eb566f0.jpg";